__turbopack_context__.v({
  "accordionSlideOverwrite": "landingPage-module-scss-module__76blcq__accordionSlideOverwrite",
  "exploreTextContainer": "landingPage-module-scss-module__76blcq__exploreTextContainer",
  "fadeIn": "landingPage-module-scss-module__76blcq__fadeIn",
  "fadeOut": "landingPage-module-scss-module__76blcq__fadeOut",
  "pageContainer": "landingPage-module-scss-module__76blcq__pageContainer",
  "scaleIn": "landingPage-module-scss-module__76blcq__scaleIn",
  "scaleOut": "landingPage-module-scss-module__76blcq__scaleOut",
  "screen": "landingPage-module-scss-module__76blcq__screen",
  "subtitleText": "landingPage-module-scss-module__76blcq__subtitleText",
  "titleText": "landingPage-module-scss-module__76blcq__titleText",
  "zoomIn": "landingPage-module-scss-module__76blcq__zoomIn",
  "zoomOut": "landingPage-module-scss-module__76blcq__zoomOut",
});
